/**
 * 12 Rollen im QM8D-System.
 * Synchron zu backend/config/seeds/role_permissions.json
 */

export const ROLES = [
  {
    key: 'admin',
    name: 'Administrator',
    description: 'Vollzugriff auf alle Funktionen und Systemkonfiguration.',
    totpRequired: true,
    scope: 'System-weit',
    keyPerms: ['Benutzerverwaltung', 'Systemkonfiguration', 'Alle Reklamationen', 'Audit-Log', 'KI-Prompts pflegen'],
  },
  {
    key: 'gbl',
    name: 'Geschäftsbereichsleiter (GBL)',
    description: 'Übergeordnete Ebene für strategische Entscheidungen und Eskalation.',
    totpRequired: true,
    scope: 'Geschäftsbereich',
    keyPerms: ['Eskalations-Ziel L2/L3', 'Management-Reports', 'Werkübergreifende Auswertung'],
  },
  {
    key: 'zqm',
    name: 'ZQM (Zentrale Qualitätsleitung)',
    description: 'Zentrale Qualitätsleitung und Reklamations-Freigabe.',
    totpRequired: true,
    scope: 'System-weit (außer Admin-Funktionen)',
    keyPerms: ['Reklamationsfreigabe', 'Q2-Koordination', 'Duale ZQM-Zuweisung', 'D5/D7 Freigabe'],
  },
  {
    key: 'manager',
    name: 'Manager',
    description: 'Fachliche Leitung, Vorgesetzten-Eskalation.',
    totpRequired: false,
    scope: 'Abteilung/Team',
    keyPerms: ['Eskalations-Ziel L1', 'Delegation', 'Freigabe D5/D7'],
  },
  {
    key: 'werksleiter',
    name: 'Werksleiter',
    description: 'Werk-spezifische Verantwortung, Werk-Scope.',
    totpRequired: false,
    scope: 'Eigenes Werk',
    keyPerms: ['Werks-Scope alle Rekls.', 'Eskalations-Ziel Werk', 'Werks-KPIs'],
  },
  {
    key: 'wqs',
    name: 'WQS (Werks-Qualitätssicherung)',
    description: 'Operative Qualitätsprüfung am Werk, Wareneingang, Q2-Anlage.',
    totpRequired: false,
    scope: 'Eigenes Werk',
    keyPerms: ['Reklamationen anlegen', 'Q2 direkt (Wareneingang)', 'D0-D8 bearbeiten'],
  },
  {
    key: 'editor',
    name: 'Redakteur',
    description: 'Erweiterte Bearbeitung, Katalog- und Template-Pflege.',
    totpRequired: false,
    scope: 'System-weit (Content)',
    keyPerms: ['Kataloge pflegen (Kunden, Produkte, Lieferanten)', 'E-Mail-Templates', 'i18n-Keys'],
  },
  {
    key: 'bearbeiter',
    name: 'Sachbearbeiter',
    description: 'Standard-Bearbeiter für Reklamationen.',
    totpRequired: false,
    scope: 'Eigene Reklamationen',
    keyPerms: ['Reklamationen bearbeiten', 'Maßnahmen anlegen', 'KI-Funktionen nutzen'],
  },
  {
    key: 'ersteller',
    name: 'Ersteller / Melder',
    description: 'Reine Erstellung, keine umfassende Bearbeitung.',
    totpRequired: false,
    scope: 'Eigene Einträge',
    keyPerms: ['Reklamation anlegen', 'Eigene Rekls. einsehen'],
  },
  {
    key: 'analyst',
    name: 'Analyst',
    description: 'Lesender Zugriff auf Dashboard und Analytics.',
    totpRequired: false,
    scope: 'System-weit (Lesen + Export)',
    keyPerms: ['Dashboard', 'Analytics', 'Export Reports (PDF/Excel)'],
  },
  {
    key: 'viewer',
    name: 'Betrachter',
    description: 'Nur Lese-Zugriff im Werks-Scope.',
    totpRequired: false,
    scope: 'Eigenes Werk (Lesen)',
    keyPerms: ['Reklamationen ansehen'],
  },
  {
    key: 'user',
    name: 'Basis-Benutzer',
    description: 'Minimaler Zugriff, nur eigenes Profil.',
    totpRequired: false,
    scope: 'Eigenes Profil',
    keyPerms: ['Profil bearbeiten', 'Sprache ändern'],
  },
];
